import React, {createContext, useContext, useEffect, useState} from "react";
import {keycloakClient as client} from "../hooks/useOidcClient";
import {OidcClientHookResult} from "../hooks/useOidcClient";

const OidcClientContext = createContext<OidcClientHookResult | undefined>(undefined);

export const OidcClientProvider: React.FC<{ children: React.ReactNode }> = ({children}) => {
    const [authenticated, setAuthenticated] = useState(false);
    const [userDisplayName, setUserDisplayName] = useState<string|undefined>(undefined);
    useEffect(() => {
        setAuthenticated(client.authenticated || false);
        const tParsed = client?.tokenParsed;
        setUserDisplayName(tParsed?.given_name || tParsed?.name || tParsed?.email || undefined);
    }, [client]);

    return (
        <OidcClientContext.Provider value={{
            client,
            authenticated,
            userDisplayName,
        }}>
            {children}
        </OidcClientContext.Provider>
    );
};

export const useOidcClientContext = () => {
    const context = useContext(OidcClientContext);
    if (!context) {
        throw new Error("useOidcClientContext debe usarse dentro de OidcClientProvider");
    }

    return context;
};
